import { render, staticRenderFns } from "./Lesson.vue?vue&type=template&id=ddef9f4e&scoped=true"
import script from "./Lesson.vue?vue&type=script&lang=js"
export * from "./Lesson.vue?vue&type=script&lang=js"
import style0 from "./Lesson.vue?vue&type=style&index=0&id=ddef9f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddef9f4e",
  null
  
)

export default component.exports